import React from 'react';
import styles from './styles.scss';
import horizontalTimeline from './assets/horizontal_timeline.png';
import verticalTimeline from './assets/vertical_timeline.png';

function StartupTimeline () {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-9 col-center">
          <h1 className={`${styles.heading} bold-italics blue text-center mb50`}>
            How can you pull this off in 30 days?
          </h1>
          <p className={`${styles.subTitle} text-center alt-text demi-bold mb50`}>one product manager and two designers all working at the same time</p>
        </div>
      </div>
      <div className="row">
        <div className={`${styles.imageContainer} col-sm-10 col-xs-10 col-center`}>
          <img src={horizontalTimeline} className="hidden-xs" alt="startup timeline horizontal" />
          <img src={verticalTimeline} className="visible-xs" alt="startup timeline vertical" />
        </div>
      </div>
    </div>
  );
}

export default StartupTimeline;



// WEBPACK FOOTER //
// ./src/components/StartupTimeline/index.js